<template>
  <div v-if="ticket_info" class="ticket_info">
    <div class="ticket_info__left">
      <div class="ticket_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="row">
            <div class="col-md-5 col-xs-5">
              <router-link
                  v-if="ticket_info.device_fid"
                  :to="'/device/' + ticket_info.device_fid"
                  @click.native="cancel"
                  class="link"
              >
                <fg-input
                    v-model="device_name"
                    type="text"
                    :label="translate('support.device')"
                    readonly
                />
              </router-link>
            </div>
            <div class="col-md-3 col-xs-3">
              <fg-input
                  v-model="ticket_info.user_name"
                  type="text"
                  :label="translate('support.user')"
                  readonly
              />
            </div>

            <div class="col-md-2 col-xs-2">
              <fg-input
                  v-model="created"
                  type="text"
                  :label="translate('support.create')"
                  readonly
              />
            </div>

            <div class="col-md-2 col-xs-2">
              <fg-input
                  v-model="updated"
                  type="text"
                  :label="translate('support.update')"
                  readonly
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-xs-3">
              <label> {{ translate('support.executor') }} </label>
              <tree-select
                  v-model="ticket_info.executor_user_id"
                  :options="executor_list"
                  :placeholder="translate('support.executor')"
                  :clearable="false"
                  :searchable="true"
                  @input="change_executor"
              />
            </div>
            <div class="col-md-3 col-xs-3">
              <label> {{ translate('support.status') }} </label>
              <tree-select
                  v-model="new_status"
                  :options="action_list"
                  :placeholder="translate('support.status')"
                  :clearable="false"
                  :searchable="false"
                  @input="change_status"
              />
            </div>
          </div>

          <div class="row messages">
            <div class="col-md-12 messages">
              <label>{{ translate('support.message') }}</label>
              <div class="message_list" id="message_list">
                <div
                    class="message"
                    v-for="(msg, key) in ticket_info.data"
                    :key="key"
                    :class="{right : msg.owner, system : [3, 4, 5, 6, 7].includes(Number(msg.action_type)), last_message : key === ticket_info.data.length - 1}"
                >
                  <div class="message_header">
                    <span class="user">{{ msg.user_name }}</span>
                    <span class="time">{{ get_date(msg.ts_create) }}</span>
                  </div>
                  <div class="message_body">
                    <pre class="pre" v-html="msg.message"></pre>
                  </div>
                </div>
              </div>

              <div class="action_list">
                <div class="action"
                     v-for="(action, key) in action_message"
                     :key="key"
                >
                  <div class="action_left text_wrap">
                    <textarea v-if="action.text" class="input_text" type="text" name="" :data_input="action.action_name" v-model="action.value"></textarea>
                  </div>
                  <div class="action_right">
                    <button
                        name="button"
                        class="btn btn-success btn-fill"
                        @click="send_answer(action, ticket_info.id)"
                        :disabled="!action.value"
                    >
                      {{ action.action_name === "Message" ? "Send" : action.action_name }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ticket_info__right">
      <Summary type="ticket" :info="ticket_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";

export default {
  name: 'TicketInfo',
  components: {
    Summary
  },

  props: {
    ticket: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      ticket_info: {},
      new_status: null,
    }
  },

  created() {
    this.ticket_info = JSON.parse(JSON.stringify(this.ticket))
    this.new_status = this.ticket_info.status
  },

  activated() {
    this.ticket_info = JSON.parse(JSON.stringify(this.ticket))
    this.new_status = this.ticket_info.status
  },

  computed: {
    created() {
      return this.get_date(this.ticket_info.ts_create)
    },
    updated() {
      return this.get_date(this.ticket_info.ts_update)
    },
    device_name(){
      if (this.ticket_info.device_fid && this.ticket_info.device_name){
        return this.ticket_info.device_fid + " / " + this.ticket_info.device_name
      }
      return ""
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
    action_message(){
      let list = []
      for (let action of this.ticket_info.actions) {
        if (action.action_name === "Message") {
          list.push(action)
        }
      }
      return list
    },
    action_list(){
      let list = [{id: parseInt(this.ticket_info.status), label: this.ticket_status[this.ticket_info.status].title, isDisabled: true}]
      for (let action of this.ticket_info.actions) {
        if (action.action_name !== "Message") {
          list.push({id: parseInt(action.action_id), label: action.action_name})
        }
      }

      return list
    },
    executor_list(){
      return this.$store.getters.getCompanyUserList.map(user => {
        return {id: user.id, label: user.name}
      })
    },
    ticket_status () {
      return this.$store.getters.getSupportInfo.statuses
    },
  },

  watch: {
    ticket(){
      this.ticket_info = {...this.ticket}
    },
    ticket_info(){
      this.scroll_bottom()
    }
  },

  methods: {
    change_status () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.set_status, 100)
    },
    set_status(){
      if (this.new_status !== this.ticket_info.status) {
        this.$http.v1.actionAnswer({ticket_id: this.ticket_info.id, action_id: this.new_status}, (response) => {
          if (response.data.status) { // response status

            this.new_status = response.data.status
            this.ticket_info = response.data
            this.$emit('update')
            this.scroll_bottom()
          }else{
            this.global_notify('danger', this.translate('support.new_ticket_error'))
          }
        })
      }
    },
    change_executor () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.set_executor, 100)
    },
    set_executor(){
      if (this.ticket_info.executor_user_id && this.ticket_info.executor_user_id !== this.ticket.executor_user_id) {
        this.$http.v1.setExecutorTicket({ticket_id: this.ticket_info.id, executor_user_id: this.ticket_info.executor_user_id}, (response) => {
          this.ticket_info = response.data
          this.$emit('update')
        })
      }
    },
    scroll_bottom(){
      this.$nextTick(() => {
        let message_list = this.$el.querySelector("#message_list")
        message_list.scrollTop = message_list.scrollHeight;
      })
    },
    send_answer(action, ticket_id){
      let answer = {
        'ticket_id': ticket_id,
        'action_id': action.action_id
      }
      if (action.value) {
        answer.text = action.value
      }
      this.$http.v1.actionAnswer(answer, (response) => {
        if (response.data.status) {
          this.ticket_info = response.data
          this.$emit('reload')

          this.scroll_bottom() //прокрутка сообщения вниз
          this.$el.querySelector("[data_input = "+action.action_name+"]").focus() //Определение input и фокус на него после отправки
        }else{
          this.global_notify('danger', this.translate('support.new_ticket_error')) //TODO add update_ticket_error
        }
      })

    }
  }
}

</script>

<style lang='scss' scoped>
.ticket_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  .form-group{
    margin: 0;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    &__wrap{
      height: 100%;
    }

    .main_info{
      display: flex;
      flex-direction: column;
      gap: 10px;
      height: 100%;

      .messages{
        height: 100%;
      }
    }

    .message_list{
      height: 84%;
      width: 100%;
      background-color: white;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      position: relative;
      padding: 10px;
      overflow-y: scroll;
      overflow-x: hidden;
      margin-bottom: 10px;
      .message{
        position: relative;
        width: 100%;
        max-width: 70%;
        border: 1px solid #f5f5f5;
        background-color: #f5f5f5;
        border-radius: 4px;
        display: inline-block;
        padding: 10px;
        margin: 5px 0;
        float: left;
        z-index: 1;
        &::after, &::before {
          content: "";
          position: absolute;
          left: -25px;
          bottom: .5em;
          width: 1.8em;
          height: 1.8em;
          border: .5em solid white;
          border-radius: 50%;
          background: white;
          z-index: -1;
        }

        &::before {
          border-top: none;
          height: .9em;
          border-radius: 0 0 50% 50% / 0 0 100% 100%;
          background: #f5f5f5;
          border-color: #f5f5f5;
          margin-left: .9em;
        }

        &.right{
          float: right;
          background-color: #d5ffec;
          border-color: #d5ffec;
          &::after{
            left: 100.2%;
          }
          &::before {
            left: 100%;
            background: #d5ffec;
            border-color: #d5ffec;
            margin-left: -.9em;
          }
        }

        &.system{
          background-color: #f5f5f5;
          border-color: #f5f5f5;
          &::before{
            background: #f5f5f5;
            border-color: #f5f5f5;
          }
        }

        &:first-child{
          margin-top: 0;
        }

        &_header{
          .user{
            font-weight: bold;
            margin-right: 10px;
          }
        }
        &_body{
          .pre{
            border: none;
            background-color: transparent;
            padding: 0;
            margin: 0;
            font-size: 12px;
            line-height: 120%;
            font-family: "Roboto", Arial, sans-serif;
            color: inherit;
            white-space: pre-wrap;
            word-break: break-word;
            overflow-wrap: anywhere;
            overflow-x: hidden;
          }
        }
      }
    }
    .action_list{
      .action{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        &_left{
          width: 69.5%;
          height: 60px;
          textarea{
            height: 100%;
            resize: none;
            outline: none;
          }
        }
        &_right{
          width: 29.5%;
          button{
            width: 100%;
            height: 60px;
            margin: 0;
          }
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
